import React, { useLayoutEffect, useRef, useCallback, type ChangeEvent } from 'react';
import { styled } from '@compiled/react';
import isNil from 'lodash/isNil';
import { CSV_FILE_UPLOAD_TYPE } from '../../../constants';

type Props = {
	isOpen: boolean;
	onClose: () => void;
	onReceiveFile: (file: File) => Promise<void>;
};
export const FileBrowser = ({ isOpen, onClose, onReceiveFile }: Props) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useLayoutEffect(() => {
		if (isOpen) {
			if (inputRef.current) {
				// Click the input to open the file browser
				inputRef.current.click();
			}

			// No browser API to know when file upload is closed, so we call
			// onClose immediately after opening
			onClose();
		}
	}, [isOpen, onClose]);

	const onChangeHandler = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			if (!isNil(event.target.files)) {
				onReceiveFile(event.target.files[0]);
			}
			// Reset file input after sending file to parent
			const inputEl = event.target;
			inputEl.value = '';
		},
		[onReceiveFile],
	);

	return (
		<HiddenInput
			data-testid="project-create-importer-upload-flow.common.ui.file-dropzone.file-browser.hidden-input"
			type="file"
			ref={inputRef}
			multiple={false}
			accept={CSV_FILE_UPLOAD_TYPE}
			onChange={onChangeHandler}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HiddenInput = styled.input({
	visibility: 'hidden',
	position: 'absolute',
	zIndex: -1,
});
